// FNP-1500: the four listings the availability check reads.
//
// ⚠️ `complete`, `failureKind` and `failureReason` are selected on listStacks
// and listBuckets and MUST STAY SELECTED. They are the only fields that let the
// caller tell "I looked and found nothing" from "I could not look". Dropping
// them from the selection set turns every denied listing into a silent "free".

export const listCodeRepositories = `
   query listCodeRepositories($filter: CodeRepositoriesFilterInput, $limit: Int, $nextToken: String) {
       listCodeRepositories(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              name
           }
           nextToken
       }
   }
`;

// ⚠️ No filter argument exists on this query — it returns every pipeline in the
// account, so the service drains it and matches client-side.
export const listCodePipelines = `
   query listCodePipelines($nextToken: String) {
       listCodePipelines(nextToken: $nextToken) {
           items {
              name
           }
           nextToken
       }
   }
`;

// ⚠️ `targetAccount` is a TOP-LEVEL argument here, not a field on the filter
// input. FNP-1033 was caused by exactly that asymmetry between a read path and
// a delete input.
export const listStacks = `
   query listStacks($filter: ResourceNameFilterInput, $targetAccount: Boolean) {
       listStacks(filter: $filter, targetAccount: $targetAccount) {
           items {
              stackName
              stackStatus
           }
           complete
           failureKind
           failureReason
       }
   }
`;

export const listBuckets = `
   query listBuckets($filter: ResourceNameFilterInput) {
       listBuckets(filter: $filter) {
           items {
              name
           }
           complete
           failureKind
           failureReason
       }
   }
`;
